export const ACTIVISM = 'Ca';
export const ACTIVIST_SHORTS = 'Cs';
export const VOTING = 'Cv';
export const GOVERNANCE = 'Cg';
export const VULNERABILITY = 'Cvu';
export const TRIAL_USER = 2;
export const FULL_USER = 4;
export const TRIAL_PID = 42;
export const TRIAL_MEETINGID = 1752562;
export const MAX_PIDS = 5;
export default {
  ACTIVISM,
  ACTIVIST_SHORTS,
  VOTING,
  GOVERNANCE,
  VULNERABILITY,
  TRIAL_USER,
  FULL_USER,
  TRIAL_PID,
  TRIAL_MEETINGID,
  MAX_PIDS,
};
